import * as React from "react";
import autobind from "class-autobind";
import { logger } from "../../../../common/utils/logger/index";
import { Input } from "../../form/input/index";
import { ProxyDomainCheckUpdateResponse, ProxyDomainCheckUpdateRequest} from "../../../../types/api/index";
import isFQDN from "validator/lib/isFQDN";
import {InputGroup} from "../../form/input.group/index";
import {RotateLoader} from "../../loaders/rotate/index";

interface Props {
  restaurant_id: string;
  website_id: string;
  value: string;
  onChange: (subdomain: string) => void;
  check: (data: ProxyDomainCheckUpdateRequest) => Promise<ProxyDomainCheckUpdateResponse>;
  onError: (e: string) => void;
}
interface State {
  loading: boolean;
}

export class FieldDomain extends React.Component<Props, State> {

  timer?: NodeJS.Timer | number;
  initialName: string;

  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      loading: false,
    };
    this.initialName = props.value;
  }

  validate(value: string) {
    if (value && value === this.initialName) {
      return "";
    }
    else if (value && !isFQDN(value, { require_tld: true })) {
      return "Invalid domain name";
    }
    else if (value && (value.match(/\./g) || []).length < 2) {
      return "Domain name must have a subdomain such as www.example.com or order.example.com";
    }
    return "";
  }

  onChange(e: React.ChangeEvent<HTMLInputElement>) {

    const { restaurant_id, website_id } = this.props;

    const value = e.target.value;

    this.props.onChange(value);

    if (this.timer) { clearTimeout(this.timer as NodeJS.Timer); }

    const error = this.validate(value);

    if (error) {
      this.props.onError(error);
      this.setState({ loading: false });
    }
    else if (!value || (value && this.initialName === value)) {
      this.props.onError("");
      this.setState({ loading: false });
    }
    else {
      this.props.onError("");
      this.setState({ loading: true });
      this.timer = setTimeout(async () => {
        try {
          const data = await this.props.check({ restaurant_id, website_id, domain: value });
          this.props.onError(data.outcome === 1 ? data.message : "");
        }
        catch (e) {
          this.props.onError("Error validating sub-domain name, please try re-entering the name");
          logger.captureException(e);
        }
        this.setState({ loading: false });
      }, 1500);
    }
  }

  render() {
    return (
      <InputGroup
        hide={!this.state.loading}
        side="right"
        iconHtml={this.state.loading ?
          <RotateLoader size={2}/> :
          ""
        }>
        <Input
          onChange={this.onChange}
          placeholder="Enter a name to check availability"
          value={this.props.value || ""}/>
      </InputGroup>
    );
  }

}
